import { RootState } from "..";
import { SliceStatus } from "../utils";
import { topicsAdapter } from "./topicsSlice";

export const selectTopicsLoading = (state: RootState) =>
  state.topics.status === SliceStatus.LOADING;

export const selectTopicsState = (state: RootState) => state.topics;

const { selectById, selectAll } = topicsAdapter.getSelectors(selectTopicsState);

export const selectAllTopics = selectAll;

export const selectTopicById = (id: number | string) => (state: RootState) =>
  selectById(state, id);
